import PropTypes from 'prop-types'
import { useState, useEffect, useCallback } from 'react'
import { toast } from 'react-toastify'
import * as categoriaService from '../servicios/categoriasService'
import { buscarTodosPorIdCategoria } from '../servicios/subcategoriaService'
import Select from '../ui/Select'

const IndicarCategorias = ({ onChange, esScrap, esMasiva, value }) => {
  const [combosCategoria, setCombosCategoria] = useState([])
  const [categoriasSeleccionadas, setCategoriasSeleccionadas] = useState([])
  const [categoriasIniciales, setCategoriasIniciales] = useState([])
  const [botonHabilitado, setBotonHabilitado] = useState(false)

  const obtenerCategorias = async () => {
    const { data } = await buscarTodosPorIdCategoria(0, esScrap)

    setCategoriasIniciales(data)
    setCombosCategoria([
      {
        pos: 0,
        idCategoria: 0,
        categorias: [{ idSubCategoria: 0, descripcion: 'Elegir Categoría' }, ...data]
      }
    ])
  }

  const obtenerRutaCategoria = useCallback(async () => {
    try {
      if (value === 0 || !value) {
        return
      }

      const { data } = await categoriaService.buscarPorId(value)
      const categoria = data?.[0]

      if (!categoria?.root) {
        return
      }

      const path = JSON.parse(categoria.root)

      const idsPath = path.map((item) => Number(item.id)).filter((id) => id > 0)

      if (idsPath.length === 0) {
        return
      }

      const combosReconstruidos = await idsPath.reduce(
        async (accPromise, idCategoria, i) => {
          const acc = await accPromise

          const idPadre = i === 0 ? 0 : idsPath[i - 1]

          const { data: categoriasNivel } = await buscarTodosPorIdCategoria(
            idPadre,
            esScrap
          )

          acc.push({
            pos: i,
            idCategoria,
            categorias: [
              {
                idSubCategoria: 0,
                descripcion: i === 0 ? 'Elegir Categoría' : 'Elegir Subcategoría'
              },
              ...categoriasNivel
            ]
          })

          return acc
        },
        Promise.resolve([])
      )

      setCombosCategoria(combosReconstruidos)
    } catch {
      toast.error(
        'Error al cargar la categoría seleccionada. Por favor, inténtalo de nuevo.'
      )
    }
  }, [value, esScrap])

  useEffect(() => {
    obtenerCategorias()
  }, [esScrap])

  useEffect(() => {
    obtenerRutaCategoria()
  }, [obtenerRutaCategoria])

  const handleChange = async (event, pos) => {
    event.persist()
    const { value, options, selectedIndex } = event.target
    const idCategoria = value
    const selectedText = options[selectedIndex].text
    const { data: categorias } = await buscarTodosPorIdCategoria(idCategoria)

    // si cambia de categoría "padre" elimina combos hijos para forzar elija de nuevo
    let combosFiltrado = combosCategoria.slice(0, pos + 1)

    // ya que eligió subcategoría elimina la opción "Elegir Subcategoría"
    combosFiltrado = combosFiltrado.map((cmb, i) => {
      return {
        ...cmb,
        idCategoria: i === pos ? idCategoria : cmb.idCategoria,
        categorias: cmb.categorias.filter((cat) => cat.idSubCategoria !== 0)
      }
    })

    if (categorias.length > 0) {
      onChange(
        {
          currentTarget: {
            ...event.target,
            name: 'idCategoria',
            value: 0
          }
        },
        'num'
      )

      setCombosCategoria([
        ...combosFiltrado,
        {
          pos: combosFiltrado.length,
          idCategoria,
          categorias: [
            { idSubCategoria: 0, descripcion: 'Elegir Subcategoría' },
            ...categorias
          ]
        }
      ])
      setBotonHabilitado(false)
    } else {
      setCombosCategoria(combosFiltrado)
      onChange(
        {
          currentTarget: {
            ...event.target,
            name: 'idCategoria',
            value: idCategoria
          }
        },
        'num'
      )
      setCategoriasSeleccionadas((prev) => [...prev, { idCategoria, selectedText }])
      setBotonHabilitado(true)
    }
  }

  const handleSeleccionarSiguiente = () => {
    setCombosCategoria([
      {
        pos: 0,
        idCategoria: 0,
        categorias: [
          { idSubCategoria: 0, descripcion: 'Elegir Categoría' },
          ...categoriasIniciales
        ]
      }
    ])
    setBotonHabilitado(false)
  }

  return (
    <>
      <p className="descripcion-cuadro-publicacion">
        Seleccionar bien la categoría, hará qué más interesados puedan encontrar tu
        producto.
      </p>
      <div className="d-none d-md-block">
        {combosCategoria.map((cat, i) => (
          <Select
            key={`${cat.idCategoria}-${cat.pos}`}
            // importante, para que setee idCategoria de componente "Publicar.jsx" recién cuando seleccione la categoría del último combo de categorías
            name={
              i === combosCategoria.length - 1
                ? 'idCategoria'
                : `idcategoria${cat.idCategoria}`
            }
            value={cat.idCategoria}
            onChange={(e) => handleChange(e, cat.pos)}
            className="select-publicacion categorias-publicacion"
            datos={cat.categorias}
            optionMetaDatos={{ value: 'idSubCategoria', text: 'descripcion' }}
          />
        ))}
      </div>
      {esMasiva && (
        <>
          <div style={{ marginTop: '1rem' }}>
            <button
              type="button"
              className="btn btn-primary"
              disabled={!botonHabilitado}
              onClick={handleSeleccionarSiguiente}
            >
              Elegir siguiente categoría
            </button>
          </div>
          {categoriasSeleccionadas.length > 0 && (
            <div
              style={{
                marginTop: '1rem',
                display: 'flex',
                gap: '0.5rem',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <span style={{ fontWeight: 'bold' }}>Categorías seleccionadas:</span>
              {categoriasSeleccionadas.map(({ idCategoria, selectedText }) => (
                <div
                  key={idCategoria}
                  style={{
                    padding: '0.75rem 2.5rem 0.75rem 1rem',
                    background: '#f1f1f1',
                    borderRadius: '8px',
                    display: 'inline-block',
                    position: 'relative'
                  }}
                >
                  <span>
                    {idCategoria} - {selectedText}
                  </span>
                  <button
                    type="button"
                    aria-label="Quitar categoría"
                    onClick={() => {
                      const nuevasCategorias = categoriasSeleccionadas.filter(
                        (id) => id.idCategoria !== idCategoria
                      )
                      setCategoriasSeleccionadas(nuevasCategorias)
                    }}
                    style={{
                      position: 'absolute',
                      right: '0.5rem',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'transparent',
                      border: 'none',
                      fontSize: '1.2rem',
                      cursor: 'pointer'
                    }}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </>
  )
}

IndicarCategorias.propTypes = {
  onChange: PropTypes.func.isRequired,
  esScrap: PropTypes.bool,
  esMasiva: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default IndicarCategorias
